import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FraudTaskService } from '../../../services/fraud-task.service';

@Component({
  selector: 'app-fraud-monitoring-tasks-logs',
  standalone: false,
  templateUrl: './fraud-monitoring-tasks-logs.component.html'
})
export class FraudMonitoringTasksLogsComponent implements OnInit {
  dataLoading = false
  @Input() recordId!: number;
  @Output() close = new EventEmitter<boolean>();
  recordsData: any[] = [];

  constructor(
    private service: FraudTaskService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    this.dataLoading = true
    this.service.getTaskLogs(this.recordId).subscribe((data) => {
      this.recordsData = data as any[];
      this.dataLoading = false
    }, (error: any) => {

    })
  }
}
